import { format } from 'date-fns'

//função para colocar a data no formato esperado pela api
const FormatDate = (value) => {
    if (value) {
        const formated = format(value, 'yyyy.MM.dd')

        return formated;
    }
}




const FormatDatePadrao = (value) => {
    if (value !== null) {
        const formated = format(value, 'dd/MM/yyyy')
        return formated;
    }

}


// FORMATA A DATA EM HORAS E MINUTOS

const FormatHours = (value) => {
    if (value) {
        const formatted = format(value, 'HH:mm:ss')
        return formatted;
    }

}

//fornata e pega somemte o mes

const FormatMounth = (value) => {
    if (value) {
        const formated = format(value, 'MM')
        return formated;
    }

}

//fornata e pega somemte o ano

const FormatYear = (value) => {
    if (value) {
        const formated = format(value, 'yyyy')
        return formated;
    }

}
export { FormatDatePadrao, FormatDate, FormatHours, FormatMounth, FormatYear };